var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15V17.5C18.75 18.1894 18.1894 18.75 17.5 18.75H2.5C1.81062 18.75 1.25 18.1894 1.25 17.5V15C1.25 14.655 1.52938 14.375 1.875 14.375C2.22062 14.375 2.5 14.655 2.5 15V17.5H17.5V15C17.5 14.655 17.7794 14.375 18.125 14.375C18.4706 14.375 18.75 14.655 18.75 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18328 6.69168C4.93891 6.44731 4.93891 6.05231 5.18328 5.80793L9.55766 1.43356C9.80203 1.18856 10.2014 1.19168 10.4427 1.43356L14.817 5.80793C15.0614 6.05231 15.0614 6.44731 14.817 6.69168C14.6952 6.81356 14.5352 6.87481 14.3752 6.87481C14.2152 6.87481 14.0552 6.81356 13.9333 6.69168L10.6252 3.38356V14.3748C10.6252 14.7198 10.3458 14.9998 10.0002 14.9998C9.65453 14.9998 9.37516 14.7198 9.37516 14.3748V3.38356L6.06703 6.69168C5.82266 6.93606 5.42766 6.93606 5.18328 6.69168Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload1);
export default __webpack_public_path__ + "static/media/upload_1.b2950afac00580a11576b5d92dc07b09.svg";
export { ForwardRef as ReactComponent };